import { configureStore } from "@reduxjs/toolkit";
import { userReducer } from "./reducers/user";
import { productReducer } from "./reducers/product";
import { cartReducer } from "./reducers/cart";
import { wishlistReducer } from "./reducers/wishlist";
import { orderReducer } from "./reducers/order";
import { categoryReducer } from "./reducers/category";
import { notificationReducer } from "./reducers/notification";
import { auctionReducer } from "./reducers/auction";
import { offerReducer } from "./reducers/offer";
import { verificationReducer } from "./reducers/verification";
import { vendorReducer } from "./reducers/vendor";
import { sellerReducer } from "./reducers/seller";
import { eventReducer } from "./reducers/event";

const Store = configureStore({
  reducer: {
    user: userReducer,
    products: productReducer,
    cart: cartReducer,
    wishlist: wishlistReducer,
    order: orderReducer,
    categories: categoryReducer,
    notifications: notificationReducer,
    auctions: auctionReducer,
    offers: offerReducer,
    verification: verificationReducer,
    vendor: vendorReducer,
    seller: sellerReducer,
    events: eventReducer,
  },
});

export default Store;
